import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { ConfigService } from '../../config/config.service';
import { SessionService } from './session.service';
import { CommonDataService } from './common-data.service';
import { httpExtensionService } from './httpextension.service';
@Injectable()
export class ShopService {

    constructor(private http: Http, private config: ConfigService, private sessionService: SessionService, private commonDataService: CommonDataService) { }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/shop.service.ts